import { IconLoadingSpinner } from '@zoom/icons-react'
import { useEffect, useState } from 'react'
import {
  useAppSelector,
  useSelectAuth,
  useSelectOrigin,
  useSelectRunningContext,
} from '../hooks'
import { selectApp } from '../app/root'
import { useSharerDetailsQuery } from '../app/appApiQueries'

const LOADING_DURATION = 3000

const InitialLoadingScreen = () => {
  const runningContext = useSelectRunningContext()
  const [showLongText, setShowLongText] = useState(false)
  const app = useAppSelector(selectApp)!
  const auth = useSelectAuth(app)
  const filePickerType = app === 'Microsoft' ? 'OneDrive' : 'Google Drive'

  useEffect(() => {
    const id = setTimeout(() => {
      setShowLongText(true)
    }, LOADING_DURATION)

    return () => {
      clearTimeout(id)
    }
  }, [])

  const origin = useSelectOrigin()
  // this is here so it is only fetched on initial app load during collaboration. If the sharer initiates a share, the details are updated manually in the store
  /*Microsot Native Collaboration
  const inChatCollaboration =
    origin === 'Meeting Chat' &&
    app === 'Google' &&
    runningContext == 'inCollaborate'
  */
  const inChatCollaboration =
    origin === 'Meeting Chat' && runningContext == 'inCollaborate'
  useSharerDetailsQuery(app, {
    skip:
      runningContext !== 'inCollaborate' ||
      auth?.authStatus !== 1 ||
      inChatCollaboration,
  })

  return (
    <div className='mx-4 flex h-screen flex-col items-center justify-center md:mx-10'>
      <IconLoadingSpinner className='animate-spin text-[32px] text-[#0E71EB]' />

      <h1 className='mb-2 mt-4 text-base font-[590] text-[#323539]'>
        Loading {filePickerType} file picker...
      </h1>

      <p
        className={`transition-opacity duration-700 ease-in-out ${
          showLongText ? 'opacity-100' : 'opacity-0'
        } text-center text-sm font-normal text-[#6E7680]`}
      >
        This is taking longer than expected. Your files will load soon…
      </p>
    </div>
  )
}

export default InitialLoadingScreen
